import React from 'react';

// "₹149 /month" with an optional struck-through previous price and badge. When the
// founding offer is open the offer price leads and the regular price is struck through.
export const PriceTag = ({ pricing, offer, className = '', unitClass = 'text-lg font-normal' }) => {
  const founding = offer?.open && !offer?.me?.member;
  const member = offer?.me?.member;
  const main = member ? offer.me.locked_price_inr : founding ? offer.price_inr : pricing.pro_price_inr;
  const was = member || founding ? pricing.pro_price_inr : pricing.original_price_inr;
  return (
    <p className={className}>
      {was > main && <span className="line-through opacity-50 text-xl mr-2">₹{was}</span>}
      ₹{main} <span className={unitClass}>/{pricing.period_label}</span>
      {(member || founding) ? (
        <span className="ml-2 align-middle text-xs font-bold bg-amber-400 text-gray-900 rounded-full px-2.5 py-1">
          {member ? 'Founding member' : 'Founding price'}
        </span>
      ) : pricing.badge && (
        <span className="ml-2 align-middle text-xs font-bold bg-amber-400 text-gray-900 rounded-full px-2.5 py-1">{pricing.badge}</span>
      )}
    </p>
  );
};
